import Text from 'components/corporatiu/Text';
import Titol from 'components/corporatiu/Titol';

export default function MissioPrincipis(props) {
    const { items } = props;

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            <Text text={items?.descripcio} className='gapAfterRow' />
        </>
    );
}
